module.exports = __webpack_public_path__ + "static/media/HeroTomatoSalad.dbbc3b02.jpg";